import { type Dispatch, type SetStateAction } from 'react';

import { type INavLinks, type TSectionAnchor } from 'shared/settings/routes';
import { setHash } from 'shared/utils/setHash';

export const DATA_AS_NAV_TAB_ATTR = 'data-as-nav-tab';

export function getNavLinksFromSections(): INavLinks[] {
  const sections = document.querySelectorAll<HTMLElement>(`section[id][${DATA_AS_NAV_TAB_ATTR}]`);

  if (sections.length < 1) {
    return [];
  }

  return Array.from(sections).reduce((accumulator, section) => {
    const id = section.getAttribute('id');
    const title = section.getAttribute(DATA_AS_NAV_TAB_ATTR);

    if (title && id) {
      accumulator.push({
        offsetHeight: section.offsetHeight,
        offsetTop: section.offsetTop,
        title,
        value: id as TSectionAnchor,
      });
    }

    return accumulator;
  }, Array.of<INavLinks>());
}

export function updateActiveSection(
  sections: INavLinks[],
  onActiveSection: Dispatch<SetStateAction<TSectionAnchor>>,
): void {
  if (sections.length < 1) {
    return;
  }

  const scrollY = window.pageYOffset;

  sections.forEach(section => {
    const sectionTop = section.offsetTop - 100;

    if (section.value && scrollY > sectionTop && scrollY <= sectionTop + section.offsetHeight) {
      onActiveSection(section.value as TSectionAnchor);
      setHash(section.value);
    }
  });
}
